

/**
 * TagManager
 *  - pushes data to dataLayer
 *  
*/

export const TagManager = (args) => {

    // Default settings
    const defaults = {
        data: false,
        format: 'standard',
        event: false
    }

    // Formatters
    const formatters = {
        standard: formatter_standard,
        mini: formatter_mini,
        extended: formatter_extended,
    }

    // Merge args and defaults to settings object
    const settings = Object.assign(defaults, args);

    // console.log(settings);
    // Format data
    if( settings.format && settings.data && formatters.hasOwnProperty(settings.format)) {
        settings.data = formatters[settings.format](settings.data)
    }

    if(settings.event && EVENTS.hasOwnProperty(settings.event)){
        const eventArray = EVENTS[settings.event]
        eventArray.forEach(trigger => {
            trigger.callback(settings.data, trigger.event)
        });

    } else if(settings.data) {
        trigger_ga(settings.data, false)
    }

}


/**
 * 
 *  Trigger functions for each data reciever
 * 
 */

// Google Analytics
export const trigger_ga = (data, event) => {

    // Make sure dataLayer exists
    if (window.dataLayer === undefined) {
        window.dataLayer = []
    }
    if (data) {
        window.dataLayer.push({ data: data })
    }
    if (event) {
        window.dataLayer.push({event: event});
    }
}



// // Facebook Pixel
export const trigger_fb = (data, event) => {
    if( typeof window.fbq === "function" ) {
        window.fbq('trackCustom', event, { 'data': fb_translation(data) });
    } else {
        console.debug('trackCustom', event, { 'data': fb_translation(data) })
    }
}

export const fb_translation = (data) => {

    const fuel = {
        diesel: 'Diesel',
        gasoline: 'Bensin',
        electric: 'El',
        hybrid: ['Elhybrid', 'Laddhybrid']
    }

    const state = {
        new: 'Ny',
        used: 'Begagnad'
    }

    const transmission = {
        automatic: 'Automat',
        manual: 'Manuell'
    }

    // Loop over translation objects
    Object.entries({fuel, state, transmission}).forEach(([key, table]) => {

        // Check if translation key is set in  data object
        if(data[key] && typeof data[key] === 'string' ) {
            let translated = 'other' // default to other
            // Loop over object and compare value
            Object.entries(table).every( ([ translatedKey, value]) => {
                if( typeof value === 'string' && data[key] === value) {
                    translated = translatedKey
                    return false
                } else if( typeof value === 'object' && value.includes(data[key])) {
                    translated = translatedKey
                    return false
                }
                return true
            })
            data[key] = translated
        }        
    });

    return data
}


/**
 * 
 *  Tag formatters
 * 
 */

 export const formatter_mini = (car) => {
    return {
        make: car.manufacturer,
        model: car.modelSeries,
        price: car.price,
    }
}
export const formatter_standard = (car) => {
    return {
        anlaggning: car.city,
        make: car.manufacturer,
        model: car.modelSeries,
        price: car.price,
        vehicleId: car.waykeId
    }
}

export const formatter_extended = (car) => {

    let priceRange = 'High';
    if(car.price < 200000) {
        priceRange = 'Low'
    } else if( car.price < 400000) {
        priceRange = 'Mid'
    }

    return {
        vehicleId: car.waykeId,
        anlaggning: car.city,
        postal_code: car.position.zip,
        biltyp: car.segment,
        condition: car.state, // merge this in api_call
        form: null,
        fuel: car.fuelType,
        make: car.manufacturer,
        mileage_value: parseInt(car.mileage)*10, // value is in mil, but we want km
        model: car.modelSeries,
        modelYear: car.modelYear,
        price: car.price,
        priceRange: priceRange,
        transmission: car.gearboxType,
        segment: car.segment
    }
}

const EVENTS= {

        // Trigger: Konvertering på bilkortet - “Ring mig”
        CarConversionCallback: [ 
                { 
                    callback: trigger_ga,
                    event: 'carConversion'
                }, 
                { 
                    callback: trigger_fb,
                    event: 'Lead'
                }
            ],

        // Trigger: Konvertering på bilkortet - “Finansieringsförslag”
        CarConversionFinanceRequest: [ 
            { 
                callback: trigger_ga,
                event: 'carConversion'
            }, 
            { 
                callback: trigger_fb,
                event: 'Lead'
            }, 
        ],
    
        // Trigger: Konvertering på bilkortet - “Boka möte”
        CarConversionMeeting: [ 
            { 
                callback: trigger_ga,
                event: 'CarConversion'
            },
            {
                callback: trigger_fb, 
                event: 'Lead'
            } 
        ],

        // Trigger: Konvertering på bilkortet - “Provkörning”
        CarConversionTestDrive: [
            { 
                callback: trigger_ga,
                event: 'carConversion'
            },
            { 
                callback: trigger_fb,
                event: 'Lead'
            }
        ],

        // Trigger - Konvertering på bilkortet - “Köp online”
        CarEcomConversion: [
            { 
                callback: trigger_ga,
                event: 'ecomConversion'
            },
            {
                callback: trigger_fb, 
                event: 'Purchase'
            } 
        ],

        // Trigger - Bilkortet “Finanseringsintresse”
        CarFinanceInterest: [
            { 
                callback: trigger_ga, 
                event: 'carFinanceInterest',
            }, 
            { 
                callback: trigger_fb,
                event: 'Shown Interest - Loan'
            } 
        ],

        // Trigger - Bilkortet “Intresserad av bilen”
        CarInterest: [ 
            { 
                callback: trigger_ga,
                event: 'CarInterest',
                type: 'Signal'
            }, 
            {
                callback: trigger_ga,
                event: 'CarInterest'
            } 
        ],

        // Trigger - Bilkortet “Intresserad av bilen”
        CarSavedConversion: [ 
            {
                callback: trigger_ga,
                event: 'carSaveConversion'
            } 
        ],
    
    
        // Trigger - När man påbörjat sin beställning online
        EcomInitialized: [
            { 
                callback: trigger_ga,
                event: 'ecomInitialized',
            }, 
            {
                callback: trigger_fb,
                event: 'InitiateCheckout'
            } 
        ],
    
    
        // Trigger - När man navigerar bilder på en specifik bil
        CarImageClick: [ 
            {
                callback: trigger_ga,
                event: 'CarImageClick',
            },
        ],
    
    
        // Trigger - När man klickar på biluppgifter
        CarInfo: [ 
            {
                callback: trigger_ga,
                event: 'CarInfo',
            },
            {
                callback: trigger_fb,
                event: 'Shown Interest - Product Detail View',
            },
        ],
    
    
        // Trigger - När man klickar på hämta pris för försäkring
        CarInsuranceInterest: [ 
            {
                callback: trigger_ga,
                event: 'carInsuranceInterest',
            }
        ],


        // Trigger - När du klickar på utrustning
        CarEquipment: [ 
            {
                callback: trigger_ga,
                event: 'CarEquipment',
            },
            {
                callback: trigger_fb,
                event: 'Shown Interest - Product Detail View',
            }
        ],

        // Trigger - När du besöker bilkortet
        ViewContent: [ 
            {
                callback: trigger_fb,
                event: 'viewVehicle',
            },
            {
                callback: trigger_ga,
                event: 'viewVehicle',
            }
        ],

 
        // Trigger - När du klickat och räknat i TCO blocket
        ShownInterestTCO: [ 
            {
                callback: trigger_fb,
                event: 'Shown Interest - TCO',
            }
        ],

 
        // Trigger - När du laddat ner Carfax
        Carfax: [ 
            {
                callback: trigger_ga,
                event: 'Carfax',
            }
        ],

        // Trigger - När du fyllt i info om inbytesbil på bilkortet
        TradeIn: [ 
            {
                callback: trigger_ga,
                event: 'TradeIn',
            }
        ],
    
}

